import { GetStaticProps, GetStaticPaths } from 'next';
import OfferDetailController from '@components/pages/offers/[url]/OfferDetailController';
import { IOfferDetailPageProps, IStaticProps } from '@components/pages/offers/[url]/interfaces';
import { getOfferDetail, getOfferPaths } from '@components/pages/offers/[url]/getStaticPropsApi';

// HOCs
import WithRole, { rolesEnum } from '@HOCs/WithRole';

const OfferDetailPage: React.FC<IOfferDetailPageProps> = ({ urlParams, fallback }) => {
    return <OfferDetailController urlParams={urlParams} fallback={fallback} />;
};

// eslint-disable-next-line consistent-return
export const getStaticProps: GetStaticProps = async context => {
    const { locale, url } = context.params as IStaticProps;
    const offer = await getOfferDetail(url, locale);
    return { props: { urlParams: { url, locale }, fallback: offer || {} } };
};

// eslint-disable-next-line consistent-return
export const getStaticPaths: GetStaticPaths = async () => {
    const paths = await getOfferPaths();
    return paths;
};

export default WithRole(OfferDetailPage, [rolesEnum.guest]);
